<script lang="ts">
  import { useForm } from "@inertiajs/svelte";

  let theirImage: FileList;
  let customUrlError: string | null = null;
  let imageTooLarge = false;

  let form = useForm({
    email: null,
    custom_url: null,
    name: null,
    avatar: null,
  });

  function handleSubmit() {
    $form.post("/affiliates");
  }

  function setAvatar(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      $form.avatar = input.files[0];
    }
  }

  $: affiliateImage = "/images/dave.jpg";
  $: affiliateName = $form.name || "Dave";

  // Read their chosen image and display it
  $: if (theirImage && theirImage[0]) {
    imageTooLarge = false;

    // Check the image size client-side because otherwise
    // nginx will throw an error after submission and the experience
    // is very confusing.
    if (theirImage[0].size > 20 * 1024 * 1024) {
      imageTooLarge = true;
      $form.avatar = null;
    } else {
      const reader = new FileReader();

      reader.onload = function (e) {
        affiliateImage = e.target?.result?.toString() || "";
      };

      reader.readAsDataURL(theirImage[0]);
    }
  }
</script>

<div class="max-w-xl mx-auto flex flex-col">
  <p class="mb-5">Let's get you set up!</p>
  <form on:submit|preventDefault={handleSubmit}>
    <div>
      <label class="block font-medium text-xl mb-2 mt-8" for="email"
        >Your Email</label
      >
      <p class="mb-4 text-sm">
        Please use the same email you'll use to sign up for SendOwl in the next
        step. We need them to match 🙌
      </p>

      {#if $form.errors.email}
        <p class="text-red-600">{$form.errors.email}</p>
      {/if}
      <input
        class="border border-gray-300 rounded-sm px-2 py-1 mb-5 w-full"
        id="email"
        type="text"
        bind:value={$form.email}
      />
    </div>

    <label class="block font-medium text-xl mb-2 mt-8" for="customUrl"
      >Choose your custom link</label
    >
    <p class="mb-4">
      This link is special and will give visitors $10 off &mdash; feel free to
      let people know :)
    </p>
    {#if $form.errors.custom_url}
      <p class="text-red-600">{$form.errors.custom_url}</p>
    {/if}
    <div class="flex flex-row items-center mb-8">
      <span class="text-gray-700 mr-1">https://getrecut.com/</span><input
        class="border border-gray-300 rounded-sm px-2 py-1"
        class:border-red-600={customUrlError}
        id="customUrl"
        placeholder="yourname"
        type="text"
        bind:value={$form.custom_url}
      />
    </div>

    <h2 class="block font-medium text-xl mb-2 mt-8">Set up your banner</h2>
    <p class="mb-5">
      When visitors land on the Recut page they'll see something like this:
    </p>

    <div
      class="w-full max-w-md mx-auto bg-green-100 rounded-md text-bluegray-900 p-2 py-4 z-10 text-center text-md font-medium mb-5"
    >
      <div class="flex items-center justify-center -ml-4 mb-2">
        <img
          class="rounded-full h-[50px] mr-3"
          alt="affiliate avatar"
          src={affiliateImage}
        />
        <div class="flex flex-col text-left">
          <div>{affiliateName} got you a discount!</div>
        </div>
      </div>
      <div>
        Good for <strong class="font-semibold">$10 off</strong>, applied
        automatically.
      </div>
    </div>

    <p class="mb-2">
      Fill in the details as you'd like them to appear in the box:
    </p>

    <label class="block font-semibold" for="name">Your Name</label>
    {#if $form.errors.name}
      <p class="text-red-600">{$form.errors.name}</p>
    {/if}
    <input
      class="border border-gray-300 rounded-sm px-2 py-1 mb-5 w-full"
      id="name"
      type="text"
      bind:value={$form.name}
    />

    <label class="block font-semibold" for="avatar">Your Avatar Image</label>
    <p class="text-gray-600 text-sm mb-2">Square is best, JPG/PNG/GIF</p>
    {#if $form.errors.avatar}
      <p class="text-red-600">{$form.errors.avatar}</p>
    {/if}
    {#if imageTooLarge}
      <p class="text-red-600">That file is too large.</p>
    {/if}
    <input
      class="border border-gray-300 rounded-sm px-2 py-8 mb-5 w-full active:bg-blue-50"
      id="avatar"
      type="file"
      on:input={setAvatar}
      bind:files={theirImage}
    />

    <h2 class="block font-medium text-xl mb-2 mt-8">
      Next: Register with SendOwl
    </h2>

    <p class="mb-5 mt-5">
      Now we'll hand you off to SendOwl (our affiliate provider) where you'll
      finish creating your account and provide your PayPal info.
    </p>

    <button
      disabled={$form.processing}
      type="submit"
      class="bg-blue-500 disabled:bg-blue-300 text-white font-semibold px-3 py-2 rounded-sm"
    >
      {$form.processing ? "Working..." : "Continue to Registration"}
    </button>
  </form>
</div>
